/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 上报唯一ID。报名页曝光：registration_page_expose，活动广场曝光：activity_square_expose,activity_lobby_expose: lobby uv统计
   */
  report_id: string;
}
export interface ActivitiesReportSendDataReportRes {
  nonce?: string;
  code?: number;
  data: {
  };
  msg?: string;
}

const ActivitiesReportSendDataReport = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<ActivitiesReportSendDataReportRes>(
    '/wemeet-tapi',
    '/v2/activities/report/send-data-report',
    data,
    ctx,
  );

  return res;
};

export default ActivitiesReportSendDataReport;
